import { dirname, join } from "path";
import { accessSync, constants, existsSync, mkdirSync, promises, writeFileSync } from "fs";
import { homedir } from "node:os";
import * as lockfile from "proper-lockfile";
import { Injectable, createInterfaceId } from "@gitlab/needle";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { ConfigService } from "@gitlab-org/config";
import { UserService, withTimeout } from "@gitlab-org/core";
import { z } from "zod";
//#region src/persistent_storage.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const PersistentStorage = createInterfaceId("PersistentStorage");
let _DefaultPersistentSto;
(class {
	static {
		[_DefaultPersistentSto, _initClass$1] = _applyDecs$1(this, [Injectable(PersistentStorage, [Logger])], []).c;
	}
	#storagePath;
	#logger;
	#state;
	constructor(logger, storagePath) {
		this.#logger = withPrefix(logger, "[PersistentStorage]");
		try {
			if (storagePath) this.#storagePath = storagePath;
			else {
				const baseDir = process.env.GITLAB_LSP_STORAGE_DIR || homedir();
				this.#storagePath = join(baseDir, ".gitlab", "storage.json");
			}
			this.#logger.info(`Initializing storage at: ${this.#storagePath}`);
			this.#initialize();
		} catch (error) {
			this.#logger.error("Failed to construct PersistentStorage:", error);
			this.#state = {
				status: "failed",
				error
			};
		}
	}
	#initialize() {
		try {
			const dir = dirname(this.#storagePath);
			this.#logger.debug(`Creating directory: ${dir}`);
			if (!existsSync(dir)) {
				mkdirSync(dir, { recursive: true });
				this.#logger.debug(`Directory created: ${dir}`);
			}
			try {
				accessSync(dir, constants.W_OK);
			} catch (err) {
				const error = /* @__PURE__ */ new Error(`Cannot write to directory: ${dir}`);
				this.#logger.error("Directory write permission error:", err);
				throw error;
			}
			if (!existsSync(this.#storagePath)) {
				this.#logger.debug("Creating initial storage file");
				writeFileSync(this.#storagePath, JSON.stringify({}), {
					encoding: "utf8",
					mode: 384
				});
				this.#logger.debug("Set file permissions to 0600 (owner read/write only)");
			} else try {
				accessSync(this.#storagePath, constants.R_OK | constants.W_OK);
				this.#logger.debug("Storage file is accessible");
			} catch (err) {
				const error = /* @__PURE__ */ new Error(`Cannot access storage file: ${this.#storagePath}`);
				this.#logger.error("Storage access error:", err);
				throw error;
			}
			this.#state = { status: "initialized" };
			this.#logger.info("Persistent storage initialized successfully");
		} catch (error) {
			this.#state = {
				status: "failed",
				error
			};
			this.#logger.error("Failed to initialize persistent storage", error);
		}
	}
	isInitialized() {
		return this.#state?.status === "initialized";
	}
	getStoragePath() {
		return this.#storagePath;
	}
	async #readStorage() {
		try {
			const content = await promises.readFile(this.#storagePath, "utf8");
			return JSON.parse(content);
		} catch (error) {
			this.#logger.error("Failed to read storage file, recreating with empty data", error);
			try {
				if (existsSync(this.#storagePath)) {
					await promises.unlink(this.#storagePath);
					this.#logger.info("Corrupted storage file removed");
				}
				const emptyData = {};
				await promises.writeFile(this.#storagePath, JSON.stringify(emptyData, null, 2), {
					encoding: "utf8",
					mode: 384
				});
				this.#logger.info("Storage file recreated with empty data and restrictive permissions");
				return emptyData;
			} catch (recreateError) {
				this.#logger.error("Failed to recreate storage file", recreateError);
				return {};
			}
		}
	}
	async #writeStorage(data) {
		try {
			await promises.writeFile(this.#storagePath, JSON.stringify(data, null, 2), "utf8");
		} catch (error) {
			this.#logger.error("Failed to write storage file", error);
			throw error;
		}
	}
	async #withLock(operation) {
		let releaseLock = null;
		try {
			if (!existsSync(this.#storagePath)) {
				this.#logger.debug("Storage file does not exist, creating it before locking");
				await promises.writeFile(this.#storagePath, JSON.stringify({}), {
					encoding: "utf8",
					mode: 384
				});
			}
			releaseLock = await lockfile.lock(this.#storagePath, {
				retries: {
					retries: 5,
					minTimeout: 100,
					maxTimeout: 1e3
				},
				stale: 5e3
			});
			return await operation();
		} catch (error) {
			this.#logger.error("Lock operation failed", error);
			throw error;
		} finally {
			if (releaseLock) try {
				await releaseLock();
			} catch (error) {
				this.#logger.error("Failed to release lock", error);
			}
		}
	}
	async get(key) {
		try {
			if (!this.isInitialized()) {
				this.#logger.error(`Storage is not initialized: ${this.#state?.status === "failed" && this.#state.error.message || "unknown error"}`);
				throw new Error("Storage is not initialized");
			}
			this.#logger.debug(`Getting value for key: ${key}`);
			const value = (await this.#readStorage())[key];
			if (value === void 0) {
				this.#logger.debug(`No value found for key: ${key}`);
				return;
			}
			return value;
		} catch (error) {
			this.#logger.error(`Storage get error for key: ${key}`, error);
			throw error;
		}
	}
	async set(key, value) {
		if (!this.isInitialized()) throw new Error("Storage is not initialized");
		this.#logger.debug(`Setting value for key: ${key}`);
		await this.#withLock(async () => {
			const data = await this.#readStorage();
			data[key] = value;
			await this.#writeStorage(data);
			this.#logger.debug(`Successfully set value for key: ${key}`);
		});
	}
	async delete(key) {
		if (!this.isInitialized()) throw new Error("Storage is not initialized");
		this.#logger.debug(`Deleting value for key: ${key}`);
		await this.#withLock(async () => {
			const data = await this.#readStorage();
			if (data[key] !== void 0) {
				delete data[key];
				await this.#writeStorage(data);
				this.#logger.debug(`Successfully deleted value for key: ${key}`);
			} else this.#logger.debug(`Key not found for deletion: ${key}`);
		});
	}
	close() {
		this.#logger.info("Storage closed");
		this.#state = { status: "closed" };
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/agent_platform_schemas.ts
const SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY = "selectedAgentPlatformProject";
const SelectedAgentPlatformProjectsSchema = z.record(z.string(), z.string());
z.object({ namespaceWithPath: z.string() });
//#endregion
//#region src/schemas.ts
const SELECTED_PROJECT_IN_REPOSITORY_STORAGE_KEY = "selectedProjectInRepository";
const HEARTBEAT_ACTIVITY_KEY = "heartbeatActivity";
const SELECTED_CHAT_MODEL_STORAGE_KEY = "selectedChatModel";
const SELECTED_ANTHROPIC_MODEL_STORAGE_KEY = "selectedAnthropicModel";
const SelectedProjectSettingSchema = z.object({
	accountId: z.string(),
	namespaceWithPath: z.string(),
	remoteName: z.string(),
	remoteUrl: z.string(),
	repositoryRootPath: z.string()
});
const HeartbeatActivitySchema = z.record(z.string(), z.number());
const globalSettingSchema = { telemetry: z.object({ enabled: z.boolean() }) };
const NotificationsSettingSchema = z.object({ channel: z.enum(["auto", "disabled"]) });
const ThemeSettingSchema = z.object({ name: z.enum([
	"auto",
	"dark",
	"light",
	"dark-high-contrast",
	"light-high-contrast"
]) });
const clientSettingSchema = {
	telemetry: z.object({ enabled: z.boolean() }),
	showWorkItemsInNewSessions: z.object({ enabled: z.boolean() }),
	notifications: NotificationsSettingSchema,
	theme: ThemeSettingSchema,
	[SELECTED_PROJECT_IN_REPOSITORY_STORAGE_KEY]: z.array(SelectedProjectSettingSchema),
	[SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY]: SelectedAgentPlatformProjectsSchema.optional(),
	[HEARTBEAT_ACTIVITY_KEY]: HeartbeatActivitySchema,
	[SELECTED_CHAT_MODEL_STORAGE_KEY]: z.string(),
	[SELECTED_ANTHROPIC_MODEL_STORAGE_KEY]: z.string()
};
//#endregion
//#region src/user_persistent_storage.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const USER_RESOLVE_TIMEOUT_MS = 1e4;
const UserPersistentStorage = createInterfaceId("UserPersistentStorage");
const GLOBAL_CLIENT = "__global__";
let _DefaultUserPersisten;
(class {
	static {
		[_DefaultUserPersisten, _initClass] = _applyDecs(this, [Injectable(UserPersistentStorage, [
			PersistentStorage,
			ConfigService,
			UserService,
			Logger
		])], []).c;
	}
	#genericStorage;
	#configService;
	#userService;
	#logger;
	constructor(genericStorage, configService, userService, logger) {
		this.#genericStorage = genericStorage;
		this.#configService = configService;
		this.#userService = userService;
		this.#logger = withPrefix(logger, "[UserPersistentStorage]");
	}
	#validateValue(key, value, schema) {
		const result = schema.safeParse(value);
		if (result.success) return result.data;
		this.#logger.warn(`Validation failed for key: ${key} - error: ${JSON.stringify(result.error.format())}, value: ${JSON.stringify(value)}`);
	}
	#buildStorageKey(userId, client, key) {
		return `${userId}:${client}:${key}`;
	}
	async #resolveUserId() {
		try {
			return (await withTimeout(this.#userService.getUser(), USER_RESOLVE_TIMEOUT_MS)).id;
		} catch (error) {
			this.#logger.warn("Failed to resolve user ID", error);
			return;
		}
	}
	async #getValue(client, key, schema) {
		try {
			const userId = await this.#resolveUserId();
			if (!userId) {
				this.#logger.warn("No user ID available");
				return;
			}
			const storageKey = this.#buildStorageKey(userId, client, key);
			this.#logger.debug(`Getting value for key: ${key} - userId: ${userId}, client: ${client}`);
			const value = await this.#genericStorage.get(storageKey);
			if (value === void 0) {
				this.#logger.debug(`No value found for key: ${key}`);
				return;
			}
			const validated = this.#validateValue(key, value, schema);
			if (validated === void 0) this.#logger.warn(`Stored value failed validation for key: ${key}`);
			return validated;
		} catch (error) {
			this.#logger.error(`Storage get error for key: ${key}`, error);
			return;
		}
	}
	async #setValue(client, key, value, schema) {
		const userId = await this.#resolveUserId();
		if (!userId) {
			this.#logger.warn("No user ID available, cannot set value");
			return;
		}
		let parsedValue;
		try {
			parsedValue = schema.parse(value);
		} catch (error) {
			this.#logger.error(`Validation failed for key: ${key}`, error);
			throw new Error(`Invalid value for key ${key}: ${error}`);
		}
		const storageKey = this.#buildStorageKey(userId, client, key);
		this.#logger.debug(`Setting value for key: ${key} - userId: ${userId}, client: ${client}`);
		await this.#genericStorage.set(storageKey, parsedValue);
		this.#logger.debug(`Successfully set value for key: ${key}`);
	}
	async #deleteValue(client, key) {
		const userId = await this.#resolveUserId();
		if (!userId) {
			this.#logger.warn("No user ID available, cannot delete value");
			return;
		}
		const storageKey = this.#buildStorageKey(userId, client, key);
		this.#logger.debug(`Deleting value for key: ${key} - userId: ${userId}, client: ${client}`);
		await this.#genericStorage.delete(storageKey);
		this.#logger.debug(`Successfully deleted value for key: ${key}`);
	}
	async get(key) {
		const client = this.#client;
		if (!client) return;
		return await this.#getValue(client, key, clientSettingSchema[key]);
	}
	async set(key, value) {
		const client = this.#client;
		if (!client) {
			this.#logger.warn("No client name available, cannot set value");
			return;
		}
		await this.#setValue(client, key, value, clientSettingSchema[key]);
	}
	async delete(key) {
		const client = this.#client;
		if (!client) {
			this.#logger.warn("No client name available, cannot delete value");
			return;
		}
		await this.#deleteValue(client, key);
	}
	async getGlobal(key) {
		return await this.#getValue(GLOBAL_CLIENT, key, globalSettingSchema[key]);
	}
	async setGlobal(key, value) {
		return this.#setValue(GLOBAL_CLIENT, key, value, globalSettingSchema[key]);
	}
	async deleteGlobal(key) {
		return this.#deleteValue(GLOBAL_CLIENT, key);
	}
	get #client() {
		const client = this.#configService.get("clientInfo.name");
		if (!client) {
			this.#logger.warn("No client name in config");
			return;
		}
		return client;
	}
	static {
		_initClass();
	}
});
//#endregion
export { _DefaultPersistentSto as DefaultPersistentStorage, _DefaultUserPersisten as DefaultUserPersistentStorage, HEARTBEAT_ACTIVITY_KEY, PersistentStorage, SELECTED_AGENT_PLATFORM_PROJECT_STORAGE_KEY, SELECTED_ANTHROPIC_MODEL_STORAGE_KEY, SELECTED_CHAT_MODEL_STORAGE_KEY, SELECTED_PROJECT_IN_REPOSITORY_STORAGE_KEY, ThemeSettingSchema, UserPersistentStorage };

//# sourceMappingURL=index.mjs.map